import { StyledSVG } from '../../Atoms/SVG/styles'
import { StyledFlex } from '../../Molecules/Flex/styles'
import { StyledGrid } from '../../Molecules/Grid/styles'
import { styled } from '../../Styles/stitches.config'
import { KlippekortBGImage } from '../../Assets/Images'

export const PriceContainer = styled('div', {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoRows: '1fr',
    gridTemplateColumns: '1fr auto',

    [`& ${StyledGrid}`]: {
        alignItems: 'center',
        fontWeight: 400,
        p: '$2 $3',

        '&:first-child': {
            bgc: '$primary600',
            color: '$white',
            fontSize: 22,
            justifyContent: 'space-between',
        },

        '&:last-child': {
            bgc: '$primary400',
            color: '$primary600',
        },
    },
})

export const ServiceContainer = styled('div', {
    background: `url(${KlippekortBGImage}), linear-gradient(to right, $primary200, #BEDAE7)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'grid',
    gap: '$2',
    p: '$3',

    [`& ${StyledGrid}`]: {
        alignItems: 'start',
        gridTemplateColumns: '1fr 55px',

        [`& ${StyledFlex}`]: {
            alignItems: 'baseline',
        },

        [`& ${StyledSVG}`]: {
            size: 55,
        },
    },
})

export const StyledPackageCard = styled('div', {
    border: '1px solid $primary600',
    br: '$2',
    color: '$primary600',
    fontWeight: 600,
    overflow: 'hidden',
})
